export default class TokenMalformedException extends Error {
  constructor(message: string) {
    super(message);
  }
}